import React, { useState } from "react"
import Header from "../components/Header/Header"
import Home from "../components/Home/Home"
import About from "../components/About/About"
import Gallery from "../components/Gallery/Gallery"
import Sidebar from "../components/Sidebar/Sidebar"
import Backdrop from "../components/Backdrop/Backdrop"
import Contact from "../components/Contact/Contact"
import Services from "../components/Services/Services"
import Testimonials from "../components/Testimonials/Testimonials"
import Footer from "../components/Footer/Footer"
import { Helmet } from "react-helmet"
import SimpleReactLightbox from "simple-react-lightbox"

import "normalize.css"
import "../layout.css"

function Index() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggle = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }
  return (
    <div style={{ height: "100%" }}>
      <Helmet>
        <html lang="en" />
        <meta
          charSet="utf-8"
          name="description"
          content="Right Choice Renovations provides quality woodworking and renovations across Ottawa"
        />
        <title>Right Choice Renovations</title>
      </Helmet>
      <Header toggle={toggle} isSidebarOpen={isSidebarOpen} />
      <Sidebar show={isSidebarOpen} hide={toggle} />
      {isSidebarOpen ? <Backdrop click={toggle} /> : null}
      <Home />
      <About />
      <SimpleReactLightbox>
        <Gallery />
      </SimpleReactLightbox>
      <SimpleReactLightbox>
        <Services />
      </SimpleReactLightbox>
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  )
}

export default Index
